module.exports = __webpack_public_path__ + "img/RajadaVento.74bad667.svg";